(() => {
  const initTracking = (root = document) => {
    root.querySelectorAll('[data-tohfa-track]').forEach((section) => {
      const form = section.querySelector('[data-track-form]');
      if (!form || form.dataset.ready === 'true') return;
      form.dataset.ready = 'true';
      const error = form.querySelector('[data-track-error]');
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const order = form.elements.order_number;
        const phone = form.elements.phone;
        const missing = !order.value.trim() || !phone.value.trim();
        order.setAttribute('aria-invalid', String(!order.value.trim()));
        phone.setAttribute('aria-invalid', String(!phone.value.trim()));
        if (missing) {
          error.textContent = document.documentElement.lang.startsWith('fr') ? 'Veuillez renseigner le numéro de commande et le téléphone.' : 'يرجى إدخال رقم الطلب ورقم الهاتف.';
          error.hidden = false;
          (!order.value.trim() ? order : phone).focus();
          return;
        }
        if (!section.dataset.whatsapp) {
          error.textContent = document.documentElement.lang.startsWith('fr') ? 'Configurez le numéro WhatsApp dans les paramètres de la section.' : 'يرجى إضافة رقم واتساب من إعدادات القسم.';
          error.hidden = false;
          return;
        }
        error.hidden = true;
        const message = section.dataset.message.replace('[order_number]', order.value.trim()).replace('[phone]', phone.value.trim());
        window.open(`https://wa.me/${section.dataset.whatsapp}?text=${encodeURIComponent(message)}`, '_blank', 'noopener');
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initTracking());
  else initTracking();
  document.addEventListener('shopify:section:load', (event) => initTracking(event.target));
})();
